// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BrushIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BrushIcon" ref={forwardedRef} {...props}>
      <path d="M11.107 16.945a4 4 0 0 1-5.657 0l-4.95-4.95 9.192-9.193a1 1 0 0 1 1.415 0l2.428 2.429 3.438-3.438a1 1 0 0 1 1.414 0l.354.353a1 1 0 0 1 0 1.415l-3.438 3.437 2.168 2.168a1 1 0 0 1 0 1.415zM6.51 15.884a2.5 2.5 0 0 0 3.536 0l3.853-3.853-5.657-5.657-5.62 5.62 1.406 1.408 2.945-2.945 1.06 1.06-2.944 2.945zm8.45-4.914 1.096-1.097L10.4 4.217 9.304 5.313z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BrushIcon = /* @__PURE__ */ Object.assign(BrushIconComponent, {
  displayName: 'BrushIcon',
});
